import { pdfjs } from 'react-pdf';

export const PdfjsWorkerPath = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
